"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ChainedBackend {
    constructor(backends) {
        this.type = "backend";
        backends.forEach(backend => {
            if (typeof backend !== "object" || backend.type !== "backend") {
                throw "Provided backend is not an instance or a backend instance";
            }
        });
        this.backends = backends;
    }
    init(services, backendOption, globalOptions) {
        this.backends.forEach(backend => backend.init(services, backendOption, globalOptions));
    }
    read(language, namespace, callback) {
        const backendsLength = this.backends.length;
        const errorStack = [];
        const loadFromBackendAtIndex = (index, canRetry = false) => {
            if (index >= backendsLength) {
                return callback("All backend failed to load data: " + errorStack.join(", "), canRetry);
            }
            const backend = this.backends[index];
            if (backend.read) {
                try {
                    backend.read(language, namespace, (err, data) => {
                        if (data && typeof data === "object" && Object.keys(data).length > -1) {
                            callback(undefined, data);
                            saveToBackendAtIndex(index - 1, data);
                        }
                        else {
                            errorStack.push(err);
                            loadFromBackendAtIndex(index + 1, canRetry || !!data);
                        }
                    });
                }
                catch (e) {
                    errorStack.push(e);
                    loadFromBackendAtIndex(index + 1, canRetry);
                }
            }
            else {
                loadFromBackendAtIndex(index + 1, canRetry);
            }
        };
        const saveToBackendAtIndex = (index, data) => {
            if (index < 0)
                return;
            const backend = this.backends[index];
            if (backend.save) {
                backend.save(language, namespace, data);
                saveToBackendAtIndex(index - 1, data);
            }
            else {
                saveToBackendAtIndex(index - 1, data);
            }
        };
        loadFromBackendAtIndex(0);
    }
    create(languages, namespace, key, fallbackValue) {
        this.backends.forEach(b => {
            if (b.create)
                b.create(languages, namespace, key, fallbackValue);
        });
    }
}
ChainedBackend.type = "backend";
exports.default = ChainedBackend;
//# sourceMappingURL=ChainedBackend.js.map